import * as React from "react";
import { observer } from "mobx-react-lite";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { Mk8sDraftMobx } from "../../../../mst/stores/mk8s.draft";
import { ProviderDigitalOceanNodePool } from "./nodePool";
import { mk8sMobx } from "../../../../mst/kinds/mk8s/mk8s";

type RouteParams = "index";

interface Props {
  mk8s: mk8sMobx;
  mk8sDraft: Mk8sDraftMobx;
}
const ProviderDigitalOceanNodePoolContainerRaw: React.FC<Props> = ({ mk8s, mk8sDraft }) => {
  const { pathname } = useLocation();

  const { index: indexStr } = useParams<RouteParams>();
  const index = Number(indexStr);

  const d = mk8sDraft.provider_digitalocean;
  const np = d.nodePools.find((np) => np.index === index);

  if (!np) {
    return <Navigate to={`${pathname.split("/-node-pools")[0]}/-node-pools`} />;
  }

  return (
    <ProviderDigitalOceanNodePool
      mk8s={mk8s}
      mk8sDraft={mk8sDraft}
      digitalocean={d}
      nodePool={np}
      index={index}
    />
  );
};

export const ProviderDigitalOceanNodePoolContainer = observer(ProviderDigitalOceanNodePoolContainerRaw);
